import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
@Injectable()
export class BuyerMRService {

  constructor(private http: Http, private router: Router) { }

  public addMR(formdata, newArray) {
    console.log('inside services', formdata);
    console.log('newArray', newArray);
    const data =  {
      'deliveryLocation': formdata.deliveryLocation,
      'emailId': formdata.emailId,
      'itemsDetails': newArray,
      'name': formdata.name,
      'phoneNumber': formdata.phoneNumber,
      'requiredDate': formdata.requiredDate,
      'shipment': formdata.shipment
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/buyer/mr', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public listOfProducts() {
    console.log('inside services products');
    return this.http.get(environment.baseUrl + '/user/hsn/', GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public searchOfProducts(searchValue) {
    console.log('inside services products');
    const cusId = localStorage.getItem('customerID')
    const string = searchValue;
    console.log('string', string);
    // buyer/inventory/item/CU00000000004/a
    return this.http.get(environment.baseUrl+'/buyer/inventory/item/'+cusId+'/'+string , GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public listMr() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/buyer/mr', GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public paginationMR(newOffset, limit) {
   console.log('pagination', newOffset, limit);
   const token = localStorage.getItem('currentUser');
   console.log('token', token);
   const headerToken = 'Bearer ' + token;
   console.log('hk', headerToken);
   const headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/buyer/mr',
    {headers: headers, params : {
     offset: newOffset,
     limit: limit
    }})
    .map((response: Response) => {
     console.log(response.status);
     const user = response.json();
     user.responseStatus = response.status;
     console.log(user);
     return user;
   }).catch((error) => {
     console.log('error', error);
     if (error.status === 500) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 400) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 401) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     }
 });
}

   public previousPage(previousUrl) {
    console.log('on previous page', previousUrl);
     return this.http.get(environment.baseUrl + '/buyer/mr' + previousUrl, GlobalService.getHeaders())
     .map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
 }

 public NextPage(nextUrl, newOffset, limit) {
  console.log('on next page', nextUrl, newOffset, limit);
  const token = localStorage.getItem('currentUser');
  console.log('token', token);
  const headerToken = 'Bearer ' + token;
  console.log('hk', headerToken);
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', headerToken);
   return this.http.get(environment.baseUrl + '/buyer/mr',
   {headers: headers, params : {
    offset: newOffset,
    limit: limit
   }})
   .map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 400) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 401) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    }
});
}

public filterMRByURL(offset: any, limit: any) {
  console.log('href on services', offset, limit);
  const token = localStorage.getItem('currentUser');
  console.log('token', token);
  const headerToken = 'Bearer ' + token;
  console.log('hk', headerToken);
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', headerToken);
  return this.http.get(environment.baseUrl  + '/buyer/mr', {headers: headers, params : {
    offset: offset,
    limit: limit
   }})
  .map((response: Response) => {
   console.log(response.status);
   const user = response.json();
   user.responseStatus = response.status;
   console.log(user);
   return user;
 }).catch((error) => {
   console.log('error', error);
   if (error.status === 500) {
     console.log('status', error.status);
     const err = error.json();
     err.responseStatus = error.status;
     console.log('status', err.responseStatus);
     return Observable.throw(err);
   } else if (error.status === 400) {
     console.log('status', error.status);
     const err = error.json();
     err.responseStatus = error.status;
     console.log('status', err.responseStatus);
     return Observable.throw(err);
   } else if (error.status === 401) {
     console.log('status', error.status);
     const err = error.json();
     err.responseStatus = error.status;
     console.log('status', err.responseStatus);
     return Observable.throw(err);
   }
});
}

  public filterMrOffset() {
   console.log('offset');

  const token = localStorage.getItem('currentUser');
  console.log('token', token);
  const headerToken = 'Bearer ' + token;
  console.log('hk', headerToken);
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', headerToken);

   return this.http.get(environment.baseUrl + '/buyer/mr',
   {headers: headers, params : {
    offset: '0',
    limit: '10'
   }})
   .map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 400) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 401) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    }
});
  }

  public searchMR(search) {
   console.log('search', search.searchParam);
   console.log('offset', search.offsteParam);
   console.log('limit', search.limitParam);
   const token = localStorage.getItem('currentUser');
   console.log('token', token);
   const headerToken = 'Bearer ' + token;
   console.log('hk', headerToken);
   const headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/buyer/mr',
    {headers: headers, params : {
     offset: 0,
     limit: search.limitParam,
     search: search.searchParam
    }})
    .map((response: Response) => {
     console.log(response.status);
     const user = response.json();
     user.responseStatus = response.status;
     console.log(user);
     return user;
   }).catch((error) => {
     console.log('error', error);
     if (error.status === 500) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 400) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 401) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     }
 });
   }

  //  serach mr fot buyer
  public searchMRBuyer(search) {
    console.log('search', search.searchParam);
    console.log('offset', search.offsteParam);
    console.log('limit', search.limitParam);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
     return this.http.get(environment.baseUrl + '/buyer/search_bar_mr',
     {headers: headers, params : {
      offset: 0,
      limit: search.limitParam,
      search: search.searchParam
     }})
     .map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
    }
  // 

  public filterMr(buyerMRID: any) {
    console.log('inside services');
    const mrId = buyerMRID;
    const buyerId = sessionStorage.getItem('buyerId');
    console.log('mrid', mrId + buyerId);
    return this.http.get(environment.baseUrl + '/buyer/mr/' + buyerId + '/' + mrId, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
  public OnListCities() {
    console.log('inside get all cities');
    return this.http.get(environment.baseUrl + '/buyer/cities/', GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      console.log(user);
      return user;
    });
  }
}
